<!-- 库存记录跟踪详情-->
<template>
    <el-dialog :title="msg('库存记录')" :close-on-click-modal="false" 
        :visible.sync="visible" width="45%"
        :fullscreen="isMinScreen"
    >
        <div v-if="data" class="ctrl-panel">
            <h3>{{fmt('单号：%s'+"库存变化详情", [code])}}</h3>
            <div class="trace-wrap">
                <div class="trace-box">
                    <h4>{{msg('库存操作记录')}}</h4>
                    <el-timeline>
                        <el-timeline-item
                            type="danger"
                            v-for="(item, index) in data.statuses" :key="index"
                            :timestamp="item.created">
                                {{item.createrName}} : {{item.ctrl}} - {{item.label}}-{{item.remark}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
                <div>
                    <h4>{{msg("订单记录")}}</h4>
                    <el-timeline>
                        <el-timeline-item
                            type="danger"
                            v-for="(item, index) in data.traces" :key="index"
                            :timestamp="item.created">
                                {{item.remark}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
    
            </div>
        </div>
    </el-dialog>
    </template>
    
    <script>
    export default {
        name: 'StockTrace',
        comments: {
    
        },
        mounted: function(){
    
        },
        data(){
            return{
                id: null,
                data: null,
                code: null,
                visible: false
            }
        },
        computed: {
            isMinScreen: {  //是否小屏幕，浏览器
                get() {
                    var is = this.$store.state.isMinScreen;
                    return is;
                }
            },
        },
        methods: {
            showTracks(id, code){
                this.code = code;
                this.visible=true;
                this.id = id;
                this.data = null;
                this.$axios.post(this.$kit.api.inventory.traces+"?id="+id)
                    .then((result) => {
                        if(result.status){
                            this.data = result.data;
                        }else{
                            this.$message(result.msg || this.msg('获取失败'));
                        }
                    });
            }
        }
    }
    </script>
    
    <style lang="scss" scoped>
    .trace-wrap{display:flex; justify-content: space-between;}
    .trace-box{padding: 10px;}
    .detail{margin:10px;}
    .detail a{display:inline-block; margin-left: 8px;}
    </style>